import React, { useState } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const ShowPassword = ({
    id,
    name,
    label,
    value,
    onChange,
    placeholder = '',
    className = '',
    required = false,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="inputGroup">
            {label && (
                <label htmlFor={id}>
                    {label}
                </label>
            )}

            <div className="tw-relative">
                <input
                    id={id}
                    name={name}
                    type={showPassword ? 'text' : 'password'}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    required={required}
                    className={`${className} tw-min-w-[240px] tw-w-full md:tw-min-w-[340px]`}
                    autoComplete="new-password"
                    autoCapitalize="off"
                    autoCorrect="off"
                />
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="tw-absolute tw-top-1/2 tw-right-3 -tw-translate-y-1/2 tw-text-gray-600 focus:tw-outline-none"
                >
                    <FontAwesomeIcon icon={!showPassword ? faEyeSlash : faEye} />
                </button>
            </div>
        </div>
    );
};

ShowPassword.propTypes = exact({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    required: PropTypes.bool,
});

export default ShowPassword;
